import { Empty, List } from 'antd'
import { FunctionComponent, ReactNode, useState } from 'react'
import styled from 'styled-components'
import { useFetchCustomizedFieldsQuery } from '@/api/workspace-api/directory-api'
import { InitialLoadingBlock } from '@/components/common/initial-loading-block'
import CustomizedFieldItem from '@/components/kol/common/kol-cooperation-detail-drawer/custom/customized-field-item'
import EditCustomizedFieldValueModal from '@/components/kol/common/kol-cooperation-detail-drawer/custom/edit-customized-field-value-model'
import { useIntl } from '@/i18n/hooks/use-intl'
import { CustomizedField } from '@/types/schema/directory/kol-management'
import { ConfigureCollaborationNotesProperties } from '@/utils/ampli'

interface CustomizedFieldListProps {
  kolId: string
  from: ConfigureCollaborationNotesProperties['from']
}

const CustomizedFieldList: FunctionComponent<CustomizedFieldListProps> = ({
  kolId,
  from,
}) => {
  const { formatMessage } = useIntl()
  const { data, isLoading, isFetching } = useFetchCustomizedFieldsQuery({
    kolId,
    field_type: 'asset-hub',
  })

  const [modalState, setModalState] = useState<{
    open: boolean
    field?: CustomizedField
  }>({ open: false })

  if (isLoading) {
    return <InitialLoadingBlock />
  }

  return (
    <Wrapper>
      <List
        dataSource={data?.data}
        itemLayout='horizontal'
        loading={isFetching}
        locale={{
          emptyText: (
            <Empty
              description={formatMessage({
                id: 'autoreport:chart_label_empty_data',
              })}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          ),
        }}
        renderItem={(item: CustomizedField): ReactNode => {
          return (
            <CustomizedFieldItem
              item={item}
              key={item.id}
              onEdit={() => {
                setModalState({ open: true, field: item })
              }}
            />
          )
        }}
      />
      <EditCustomizedFieldValueModal
        field={modalState.field}
        from={from}
        kolId={kolId}
        open={modalState.open}
        onClose={() => {
          setModalState({ open: false })
        }}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 24px;

  .ant-empty-normal {
    margin: 0;
    padding: 6px 0;
  }
`

export default CustomizedFieldList
